import React from "react";

import { useTranslation } from "react-i18next";

import FormLanguageList from "./FormLanguageList";
import FormTranslationsActions from "./FormTranslationsActions";

import type { JSX } from "react";

import type { LanguageCode } from "../../api/ProjectAPI.types";

interface FormTranslationsHeaderProps {
  languageList?: LanguageCode[];
}

export default function FormTranslationsHeader({
  languageList,
}: FormTranslationsHeaderProps): JSX.Element {
  const { t } = useTranslation("languages");
  return (
    <div className="border-border mb-[0.9375rem] flex flex-wrap items-center justify-between gap-[0.625rem] border-b pb-[0.9375rem]">
      <div className="flex flex-col gap-[0.3125rem]">
        <h2 className="text-foreground text-[1.40625rem] font-semibold">
          {t("languageManagement")}
        </h2>
        <FormTranslationsActions />
      </div>
      <FormLanguageList languageList={languageList} />
    </div>
  );
}
